import { Component, OnInit, Input, HostBinding } from '@angular/core';

@Component({
    selector: 'true-false',
    templateUrl: './true-false.component.html',
    styleUrls: ['./true-false.component.scss'],
    standalone: false
})
export class TrueFalseComponent implements OnInit {
  @Input() value: boolean;
  @Input() trueText: string;
  @Input() falseText: string;
  @Input() trueMatIcon: string;
  @Input() falseMatIcon: string;
  @Input() iconSize: boolean = false;
  /** When true, the badge stretches to fill the parent (e.g. table cell). */
  @Input() fullCellWidth = false;

  @HostBinding('class.true-false--full-cell')
  get fullCellWidthClass(): boolean {
    return this.fullCellWidth;
  }
  
  constructor() { }

  ngOnInit() {
  }

}
